export const validateEmail = (email) => {
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
        return (true)
    }
    return (false)
}
export const roundNumber = (number = 0, digit = 2) => {
    return Math.round(number * Math.pow(10, digit)) / Math.pow(10, digit);
};

export const removeParam = (key, sourceURL) => {
    let rtn = sourceURL.split('?')[0];
    let param;
    let params_arr = [];
    const queryString =
        sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
        params_arr = queryString.split('&');
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
            // eslint-disable-next-line prefer-destructuring
            param = params_arr[i].split('=')[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = `${rtn}?${params_arr.join('&')}`;
    }
    return rtn;
};

export const thumbnail = (url, w, h) => {
    if (url) {
        return `${url.substring(0, url.lastIndexOf('.'))}_${w}x${h}${url.substring(
            url.lastIndexOf('.')
        )}`;
    } else {
        return url;
    }
}


export const verifyUUID = (uuid) =>
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
        uuid?.trim()
    );

export const numberFormat = (num, toFixed = 2) => {
    if (typeof num !== 'number' && !isNaN(num)) {
        num = parseFloat(num);
    } else if (typeof num !== 'number') {
        return;
    }

    return Number.isInteger(num) ? num : num.toFixed(2);
};

export const indexToWeekDay = (idx) => {
    switch (idx) {
        case 0:
            return 'Sun';
        case 1:
            return 'Mon';
        case 2:
            return 'Tue';
        case 3:
            return 'Wed';
        case 4:
            return 'Thur';
        case 5:
            return 'Fri';
        case 6:
            return 'Sat';
        default:
            return;
    }
};

export const sliceString = (str, num_charater = 50) => {
    return num_charater < str.length ? `${str.slice(0, num_charater)}...` : str;
};

export const titleCase = (str) => {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
}